import React,{useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { ConfirmEmail } from '../../Data';
import Util from '../../../Classes/Utils';
import { toast } from 'react-toastify';


const Confirm = () => {
    const [code, setCode] = useState("")
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        const getItem = (localStorage.getItem('User') !== null);
        if(getItem) {
            var ID = Util.decrypt(localStorage.getItem('User'));
            ConfirmEmail(ID,code).then((Result) => {
                toast.success("Email SuccessFully Confirmed, please login again");
                navigate("/Authentication")
              })
              .catch((error) => {
                if (
                  error.message.replaceAll('"', "") === "Please Confirm Your Email"
                ) {
                }
                toast.error(error.message.replaceAll('"', ""));
              });
        } else {
            toast.error("Sometheing went wrong try again later");
        }

        
    }
  return (
    <>
        {/* <div className="container mt-60"> */}
        <div className="breadcrumb-area mb-5">
				<div className="container">
					<div className="row">
						<div className="col">
							<div className="breadcrumb-container HomeShop">
								<ul>
									<li><a href="index.html" className='RemUnderline'><i className="fa fa-home"></i> Home</a></li>
									<li className="active ">Email Confirmation</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
        <form className="row justify-content-center mb-5" onSubmit={handleSubmit}>
            <div className="col-12 col-md-8">
                <div className="authenticationCard">
                    <div className="row topBar">
                        {/* <div className="col-12 text-center">
                            <button className='active'>Email Confirmation</button>
                        </div> */}
                    </div>
                    <div className="row mb-35">
                        <div className="col-12 col-md-2"><label>Code:</label></div>
                        <div className="col-12 col-md-10">
                            <input className="form-control" placeholder="Type Here" required onChange={(e) => setCode(e.target.value)}></input>
                        </div>
                    </div>
                    <div className='row text-center mt-2' style={{cursor: 'pointer'}}>
                      {/* <button> */}
                        <h5 style={{fontSize: '13px'}}>Resend Code</h5>
                      {/* </button> */}
                    </div>
                    <div className="row mb-35 submit">
                        <div className="col-12 text-center">
                            <button type='submit' className="Resend-button mt-0 btnColor"> Submit</button>
                            {/* <button type='submit' className="register-button mt-0">Register</button> */}
                        </div>
                    </div>
                </div>
            </div>
        </form>
    {/* </div> */}
    </>
  )
}

export default Confirm